import { render, staticRenderFns } from "./NewTaskForm.vue?vue&type=template&id=5f1df8a5"
import script from "./NewTaskForm.vue?vue&type=script&lang=js"
export * from "./NewTaskForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports